var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: [_vm.$style["mds-inline-message"], _vm.classObject, _vm.sizeClass],
      attrs: {
        "data-mds-version": _vm.version,
        "aria-label": _vm.iconAriaLabel,
      },
    },
    [
      _c("mds-icon", {
        class: _vm.$style["mds-inline-message__icon"],
        attrs: { name: _vm.iconName, size: _vm.iconSize },
      }),
      _vm._v(" "),
      !_vm.iconOnly
        ? _c(
            "div",
            { class: _vm.$style["mds-inline-message__body"] },
            [
              _vm._t("default", function () {
                return [_vm._v(" " + _vm._s(_vm.text) + " ")]
              }),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }